import React from 'react';
import { FaVideo, FaUser } from 'react-icons/fa';
import {useAuth } from '../AuthContext/AuthContext'
// Encabezado Component
function Welcome({redirectTransmision, child}) {
  const { dispatch } = useAuth();
  return (
    <>
      <div>
        <center>
          <br />
          <h1 className="welcome_message">Bienvenido</h1>
          <div className="welcome_message">
            <FaUser className='name-user' />
            {dispatch.nombre}
          </div>
          <div className="welcome_message">Seleccione la categoría en la cual desea emitir su voto.</div>
        </center>
        <center>
          <div>
            <button className="button-small button-transmision" onClick={redirectTransmision}>
              <FaVideo className='icon-transmision' /> Transmisión<br />en vivo
            </button>
          </div>
        </center>
      </div>
      
    </>
  );
}

export default Welcome;